// Catégories métier — Prestataires & Artistes (Événements AAE)
export const PROVIDER_CATEGORIES = [
  "Décoration",
  "Mobilier",
  "CTS",
  "Hôtesses",
  "Sécurité",
  "Plantes",
  "Animations",
  "Audiovisuel",
  "Lieu",
  "Traiteur",
  "Photographe",
  "Vidéaste",
];

export const ARTIST_CATEGORIES = [
  "Musicien",
  "Groupe de musique",
  "Acrobate",
  "Animation",
  "Spectacle",
];

export const getCategoriesForKind = (kind) =>
  kind === "artist" ? ARTIST_CATEGORIES : PROVIDER_CATEGORIES;
